import { Pipe, PipeTransform } from '@angular/core';
import { EtxeEnumsNiceLabelUtils } from '../../utils/etxe-enums-nice-label.utils';

@Pipe({
  name: 'etxeEnumDisplay',
  standalone: true,
})
export class EtxeEnumDisplayPipe implements PipeTransform {
  transform(value: unknown, type: string, arg?: unknown): string {
    const val = value as never;
    switch (type) {
      case 'offerType':
        return EtxeEnumsNiceLabelUtils.offerType(val);
      case 'residenceType':
        return EtxeEnumsNiceLabelUtils.residenceType(val);
      case 'sellerRole':
        return EtxeEnumsNiceLabelUtils.sellerRole(val);
      case 'propertyType':
        return EtxeEnumsNiceLabelUtils.propertyType(val);
      case 'subtype':
        return EtxeEnumsNiceLabelUtils.propertySubtype(val, arg as never);
      case 'floorConfig':
        return EtxeEnumsNiceLabelUtils.floorConfig(val as never, arg as never);
      case 'apartmentFloor':
        return EtxeEnumsNiceLabelUtils.apartmentFloor(val as never, arg as never);
      case 'remainingDays':
        return EtxeEnumsNiceLabelUtils.remainingDays(val as never);
      case 'geolocationType':
        return EtxeEnumsNiceLabelUtils.geolocationType(val);
      case 'land':
        return EtxeEnumsNiceLabelUtils.land(val);
      case 'house':
        return EtxeEnumsNiceLabelUtils.house(val);
      case 'apartment':
        return EtxeEnumsNiceLabelUtils.apartment(val);
      case 'commercial':
        return EtxeEnumsNiceLabelUtils.commercial(val);
      case 'professional':
        return EtxeEnumsNiceLabelUtils.professional(val);
      case 'room':
        return EtxeEnumsNiceLabelUtils.room(val);
      case 'heating':
      case 'heatingType':
        return EtxeEnumsNiceLabelUtils.heatingType(val);
      case 'energy':
        return EtxeEnumsNiceLabelUtils.heatingEnergy(val);
      case 'condition':
        return EtxeEnumsNiceLabelUtils.condition(val);
      case 'material':
        return EtxeEnumsNiceLabelUtils.constructionMaterial(val);
      case 'roofMaterial':
      case 'roof':
        return EtxeEnumsNiceLabelUtils.roofMaterial(val);
      case 'orientation':
        return EtxeEnumsNiceLabelUtils.orientation(val);
      case 'parking':
        return EtxeEnumsNiceLabelUtils.parking(val);
      case 'commonArea':
        return EtxeEnumsNiceLabelUtils.commonArea(val);
      case 'dpeState':
        return EtxeEnumsNiceLabelUtils.dpeState(val);
      case 'coOwnershipProcedureType':
        return EtxeEnumsNiceLabelUtils.coOwnershipProcedure(val);
      case 'exposure':
        return EtxeEnumsNiceLabelUtils.exposure(val);
      case 'constructionPeriod':
        return EtxeEnumsNiceLabelUtils.constructionPeriod(val);
      case 'standing':
        return EtxeEnumsNiceLabelUtils.propertyStanding(val);
      case 'view':
        return EtxeEnumsNiceLabelUtils.propertyView(val);
      case 'saleUrgency':
        return EtxeEnumsNiceLabelUtils.saleUrgency(val);
      case 'currentMarketingMode':
        return EtxeEnumsNiceLabelUtils.currentMarketingMode(val);
      case 'characteristicCategory':
        return EtxeEnumsNiceLabelUtils.characteristicCategory(val);
      case 'verificationStatus':
        return EtxeEnumsNiceLabelUtils.verificationStatus(val);
      case 'documentStatus':
        return EtxeEnumsNiceLabelUtils.documentStatus(val);
      case 'marketState':
        return EtxeEnumsNiceLabelUtils.marketState(val);
      case 'creationSource':
        return EtxeEnumsNiceLabelUtils.creationSource(val);
      case 'creationStep':
      case 'step':
        return EtxeEnumsNiceLabelUtils.creationStep(val);
      case 'mandateType':
        return EtxeEnumsNiceLabelUtils.mandateType(val);
      case 'mandateDuration':
        return EtxeEnumsNiceLabelUtils.mandateDuration(val);
      case 'sellerPriority':
        return EtxeEnumsNiceLabelUtils.sellerPriority(val);
      case 'applicationStatus':
        return EtxeEnumsNiceLabelUtils.applicationStatus(val);
      case 'applicationService':
        return EtxeEnumsNiceLabelUtils.applicationService(val);
      default:
        return String(val ?? '');
    }
  }
}
